import { render, staticRenderFns } from "./Github.vue?vue&type=template&id=bdf3ea16&scoped=true"
var script = {}
import style0 from "./Github.vue?vue&type=style&index=0&id=bdf3ea16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf3ea16",
  null
  
)

export default component.exports